/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'network-security-policy';
const componentName = 'network-security-policy-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitleEdit = `${prefix}.modalTitleEdit`;
export const modalTitleNew = `${prefix}.modalTitleNew`;
export const sectionTitleGeneral = `${prefix}.sectionTitleGeneral`;
export const nameInputLabel = `${prefix}.nameInputLabel`;
export const descriptionLabel = `${prefix}.descriptionLabel`;
export const ipReputationDbInputLabel = `${prefix}.ipReputationDbInputLabel`;
export const ipReputationDbInputPlaceholder = `${prefix}.ipReputationDbInputPlaceholder`;
export const geoDbInputLabel = `${prefix}.geoDbInputLabel`;
export const geoDbInputPlaceholder = `${prefix}.geoDbInputPlaceholder`;
export const sectionTitleRbac = `${prefix}.sectionTitleRbac`;
export const sectionTitleRules = `${prefix}.sectionTitleRules`;
export const sectionTitleDatabases = `${prefix}.sectionTitleDatabases`;

export const ENGLISH = {
    [modalTitleEdit]: 'Edit Network Security Policy',
    [modalTitleNew]: 'New Network Security Policy',
    [sectionTitleGeneral]: 'General',
    [nameInputLabel]: 'Name',
    [descriptionLabel]: 'Description',
    [ipReputationDbInputLabel]: 'IP Reputation DB',
    [ipReputationDbInputPlaceholder]: 'Select IP Reputation DB',
    [geoDbInputLabel]: 'Geo DB',
    [geoDbInputPlaceholder]: 'Select Geo DB',
    [sectionTitleRbac]: 'Role-Based Access Control (RBAC)',
    [sectionTitleRules]: 'Rules',
    [sectionTitleDatabases]: 'Databases',
};
